exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hr-sect[data-v-64bd0cf9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-preferred-size: 100%;\n      flex-basis: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 8px 0px;\n}\n.hr-sect[data-v-64bd0cf9]::before,\n.hr-sect[data-v-64bd0cf9]::after {\n  content: \"\";\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  background: #00796B;\n  height: 1px;\n  font-size: 0px;\n  line-height: 0px;\n  margin: 0px 8px;\n}\n", ""]);

// exports
